<template>
    <div class="step6">
        <h1>Aanvraagformulier</h1>
        <h2>Inkomsten per maand</h2>

        <application-stepper current-step="6" :loading="!loaded">
            <v-form @submit.prevent="submit">
                <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>

                <h3>Aanvrager</h3>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.welfareAmount"
                            prefix="€"
                            label="Uitkering"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.salaryAmount"
                            prefix="€"
                            label="Salaris"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.studentGrantAmount"
                            prefix="€"
                            label="DUO"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.alimonyAmount"
                            prefix="€"
                            label="Alimentatie"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.childRelatedBudgetAmount"
                            prefix="€"
                            label="Kindgebonden budget"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.boardingWagesAmount"
                            prefix="€"
                            label="Kostgeld"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.housingAllowanceAmount"
                            prefix="€"
                            label="Huurtoeslag"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.healthAllowanceAmount"
                            prefix="€"
                            label="Zorgtoeslag"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.personalBudgetAmount"
                            prefix="€"
                            label="PGB"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.mortgageInterestAmount"
                            prefix="€"
                            label="Voorlopige teruggave hypotheekrente"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field v-model="applicant.income.otherAmount" prefix="€" label="Overig"></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.income.pensionAmount"
                            prefix="€"
                            label="Pensioen"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6" offset-sm="6">
                        <v-float-field
                            :value="calculateIncomeTotalAmount(this.applicant.income)"
                            prefix="€"
                            label="Totaal"
                            readonly
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-file-input-dropzone
                    v-model="applicant.income.specifications"
                    tooltip="Klik hier of sleep bestanden naar dit vlak"
                    label="Voeg overzicht van inkomsten toe."
                    style="height: 200px"
                    @file-added="applicantIncomeSpecificationAdded"
                    @file-removed="applicantIncomeSpecificationRemoved"
                    :error="hasErrors('income','specifications')" :error-messages="handleErrors('income', 'specifications')"
                ></v-file-input-dropzone>

                <template v-if="applicantHouseholdAdultsShowable.length > 0">
                    <h3>Inwonende volwassenen</h3>

                    <v-card class="mx-1 my-3" v-for="adult in applicantHouseholdAdultsShowable" :key="adult.id">
                        <v-card-text>
                            <h4>Inkomsten huisgenoot {{ adult.name }}</h4>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.welfareAmount"
                                        prefix="€"
                                        label="Uitkering"
                                    ></v-float-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.salaryAmount"
                                        prefix="€"
                                        label="Salaris"
                                    ></v-float-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.studentGrantAmount"
                                        prefix="€"
                                        label="DUO"
                                    ></v-float-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.alimonyAmount"
                                        prefix="€"
                                        label="Alimentatie"
                                    ></v-float-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.childRelatedBudgetAmount"
                                        prefix="€"
                                        label="Kindgebonden budget"
                                    ></v-float-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.boardingWagesAmount"
                                        prefix="€"
                                        label="Kostgeld"
                                    ></v-float-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.housingAllowanceAmount"
                                        prefix="€"
                                        label="Huurtoeslag"
                                    ></v-float-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.healthAllowanceAmount"
                                        prefix="€"
                                        label="Zorgtoeslag"
                                    ></v-float-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.personalBudgetAmount"
                                        prefix="€"
                                        label="PGB"
                                    ></v-float-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.mortgageInterestAmount"
                                        prefix="€"
                                        label="Voorlopige teruggave hypotheekrente"
                                    ></v-float-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.otherAmount"
                                        prefix="€"
                                        label="Overig"
                                    ></v-float-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-float-field
                                        v-model="adult.income.pensionAmount"
                                        prefix="€"
                                        label="Pensioen"
                                    ></v-float-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6" offset-sm="6">
                                    <v-float-field
                                        :value="calculateIncomeTotalAmount(adult.income)"
                                        prefix="€"
                                        label="Totaal"
                                        readonly
                                    ></v-float-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-file-input-dropzone
                                        v-model="adult.income.specifications"
                                        tooltip="Klik hier of sleep bestanden naar dit vlak"
                                        label="Voeg overzicht van inkomsten toe."
                                        style="height: 200px"
                                        @file-added="householdAdultIncomeSpecificationAdded(adult, $event)"
                                        @file-removed="householdAdultIncomeSpecificationRemoved(adult, $event)"
                                        :error="hasErrors('householdAdults',adult.id,'specifications')" :error-messages="handleErrors('householdAdults',adult.id ,'specifications')"
                                    ></v-file-input-dropzone>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </template>

                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="back" :loading="backBtnClicked" :disabled="submitting">Vorige</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
                            >Volgende</v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </application-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ApplicationStepper from '../components/ApplicationStepper';
import VErrorMessages from '@/components/VErrorMessages';
import VFileInputDropzone from '@/components/VFileInputDropzone';
import VFloatField from '@/components/VFloatField';
import Attachment from '../types/Attachment';
import BackendService from '../services/BackendService';

export default {
    name: 'step6-income',
    components: {
        ApplicationStepper,
        VErrorMessages,
        VFileInputDropzone,
        VFloatField,
    },
    data: () => ({
        errorDetails: {},
        loaded: false,
        backBtnClicked: false,
        submitBtnClicked: false,
        submitting: false,

        errorMessages: [],
        applicant: {
            income: {
                welfareAmount: null,
                salaryAmount: null,
                studentGrantAmount: null,
                alimonyAmount: null,
                childRelatedBudgetAmount: null,
                boardingWagesAmount: null,
                housingAllowanceAmount: null,
                healthAllowanceAmount: null,
                personalBudgetAmount: null,
                mortgageInterestAmount: null,
                otherAmount: null,
                pensionAmount: null,
                specifications: [],
            },
            householdAdults: [],
        },
    }),
    computed: {
        ...mapGetters({ vuex: 'step6' }),
        applicantHouseholdAdultsShowable() {
            return this.applicant.householdAdults.filter(adult => adult.show);
        },
    },
    created: function() {
        const that = this;

        this.step6Load().then(function() {
            that.applicant.income.welfareAmount = that.vuex.applicant.income.welfareAmount;
            that.applicant.income.salaryAmount = that.vuex.applicant.income.salaryAmount;
            that.applicant.income.studentGrantAmount = that.vuex.applicant.income.studentGrantAmount;
            that.applicant.income.alimonyAmount = that.vuex.applicant.income.alimonyAmount;
            that.applicant.income.childRelatedBudgetAmount = that.vuex.applicant.income.childRelatedBudgetAmount;
            that.applicant.income.boardingWagesAmount = that.vuex.applicant.income.boardingWagesAmount;
            that.applicant.income.housingAllowanceAmount = that.vuex.applicant.income.housingAllowanceAmount;
            that.applicant.income.healthAllowanceAmount = that.vuex.applicant.income.healthAllowanceAmount;
            that.applicant.income.personalBudgetAmount = that.vuex.applicant.income.personalBudgetAmount;
            that.applicant.income.mortgageInterestAmount = that.vuex.applicant.income.mortgageInterestAmount;
            that.applicant.income.otherAmount = that.vuex.applicant.income.otherAmount;
            that.applicant.income.pensionAmount = that.vuex.applicant.income.pensionAmount;
            that.applicant.income.specifications = that.vuex.applicant.income.specifications;
            that.applicant.householdAdults = that.vuex.applicant.householdAdults;

            that.loaded = true;
        });
    },
    methods: {
        ...mapActions(['step6Load', 'step6Submit']),
        hasErrors(name, subkey, entity) {
            return '' !== this.handleErrors(name, subkey, entity);
        },
        handleErrors(name, subkey, entity) {
            if(this.errorDetails[name] === undefined){
                return '';
            }
            let detailObj = this.errorDetails[name];
            if(subkey !== undefined){
                if(detailObj[subkey] === undefined){
                    return '';
                }
                detailObj = detailObj[subkey];
            }
            if(entity !== undefined){
                if(detailObj[entity] === undefined){
                    return '';
                }
                detailObj = detailObj[entity];
            }

            if (this.errorDetails[name] !== undefined) {
                let errorObj = this.errorDetails[name]
                if (entity !== undefined) {
                    errorObj = this.errorDetails[name][subkey][entity]
                } else if (subkey !== undefined) {
                    errorObj = this.errorDetails[name][subkey]
                }
                let error = '';
                Object.entries(errorObj).forEach(entry => {
                    const [errorType, value] = entry;
                    error += " " + value;
                });
                return error;
            }
            return '';
        },
        calculateIncomeTotalAmount(income) {
            const incomeTotal =
                income.welfareAmount +
                income.salaryAmount +
                income.studentGrantAmount +
                income.alimonyAmount +
                income.childRelatedBudgetAmount +
                income.boardingWagesAmount +
                income.housingAllowanceAmount +
                income.healthAllowanceAmount +
                income.personalBudgetAmount +
                income.mortgageInterestAmount +
                income.otherAmount +
                income.pensionAmount;
            return incomeTotal;
        },
        attachmentRemoved(collection, attachment) {
            attachment.isInProgress = true;
            BackendService.attachmentRemove(attachment.id)
                .then(function() {
                    // reactively remove file from collection
                    collection.splice(collection.indexOf(attachment), 1);
                })
                .finally(function() {
                    attachment.isInProgress = false;
                });
        },
        applicantAttachmentAdded(collection, type, file, errorKey, errorSubkey) {
            let dis = this;
            const attachment = new Attachment();
            attachment.filename = file.name;
            attachment.isComplete = false;
            attachment.percentCompleted = 0;

            collection.push(attachment);

            BackendService.applicantAttachmentAdd(type, file, function(progressEvent) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                attachment.percentCompleted = percentCompleted;
            }).then(function (response) {
                attachment.id = response.data.data.id;
                if (errorKey !== undefined && errorSubkey !== undefined) {
                    if(dis.errorDetails[errorKey] !== undefined) {
                        dis.$delete(dis.errorDetails[errorKey], errorSubkey)
                    }
                    dis.$delete(dis.errorDetails, errorKey);
                }
            }).catch(function (error) {
                collection.splice(collection.indexOf(attachment), 1);
                if (errorKey !== undefined && errorSubkey !== undefined) {
                    dis.errorDetails[errorKey] = {};
                    dis.errorDetails[errorKey][errorSubkey] = {"fileupload": "Uploaden mislukt, mogelijk is het bestand te groot!"};
                }
            });
        },
        applicantIncomeSpecificationAdded(file) {
            return this.applicantAttachmentAdded(
                this.applicant.income.specifications,
                Attachment.prototype.TYPE_INCOME_SPECIFICATION,
                file,
                "income",
                "specifications"
            );
        },
        applicantIncomeSpecificationRemoved(attachment) {
            return this.attachmentRemoved(this.applicant.income.specifications, attachment);
        },
        householdAdultAttachmentAdded(householdAdultId, collection, type, file) {
            const attachment = new Attachment();
            attachment.filename = file.name;
            attachment.isComplete = false;
            attachment.percentCompleted = 0;

            collection.push(attachment);

            BackendService.householdAdultAttachmentAdd(householdAdultId, type, file, function(progressEvent) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                attachment.percentCompleted = percentCompleted;
            }).then(function (response) {
                attachment.id = response.data.data.id;
            }).catch(function (error) {
                collection.splice(collection.indexOf(attachment), 1);
            });
        },
        householdAdultIncomeSpecificationAdded(householdAdult, file) {
            return this.householdAdultAttachmentAdded(
                householdAdult.id,
                householdAdult.income.specifications,
                Attachment.prototype.TYPE_INCOME_SPECIFICATION,
                file
            );
        },
        householdAdultIncomeSpecificationRemoved(householdAdult, attachment) {
            return this.attachmentRemoved(householdAdult.income.specifications, attachment);
        },
        getPayload() {
            return {
                applicant: {
                    income: {
                        welfareAmount: this.applicant.income.welfareAmount,
                        salaryAmount: this.applicant.income.salaryAmount,
                        studentGrantAmount: this.applicant.income.studentGrantAmount,
                        alimonyAmount: this.applicant.income.alimonyAmount,
                        childRelatedBudgetAmount: this.applicant.income.childRelatedBudgetAmount,
                        boardingWagesAmount: this.applicant.income.boardingWagesAmount,
                        housingAllowanceAmount: this.applicant.income.housingAllowanceAmount,
                        healthAllowanceAmount: this.applicant.income.healthAllowanceAmount,
                        personalBudgetAmount: this.applicant.income.personalBudgetAmount,
                        mortgageInterestAmount: this.applicant.income.mortgageInterestAmount,
                        otherAmount: this.applicant.income.otherAmount,
                        pensionAmount: this.applicant.income.pensionAmount,
                    },
                    householdAdults: this.applicant.householdAdults.map(function(householdAdult) {
                        return {
                            income: {
                                welfareAmount: householdAdult.income.welfareAmount,
                                salaryAmount: householdAdult.income.salaryAmount,
                                studentGrantAmount: householdAdult.income.studentGrantAmount,
                                alimonyAmount: householdAdult.income.alimonyAmount,
                                childRelatedBudgetAmount: householdAdult.income.childRelatedBudgetAmount,
                                boardingWagesAmount: householdAdult.income.boardingWagesAmount,
                                housingAllowanceAmount: householdAdult.income.housingAllowanceAmount,
                                healthAllowanceAmount: householdAdult.income.healthAllowanceAmount,
                                personalBudgetAmount: householdAdult.income.personalBudgetAmount,
                                mortgageInterestAmount: householdAdult.income.mortgageInterestAmount,
                                otherAmount: householdAdult.income.otherAmount,
                                pensionAmount: householdAdult.income.pensionAmount,
                            },
                        };
                    }),
                },
            };
        },
        back: function() {
            const that = this;
            this.backBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step6Submit(this.getPayload()).finally(function() {
                that.$router.push({ name: 'step5_car' });
                that.backBtnClicked = false;
                that.submitting = false;
            });
        },
        submit: function() {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step6Submit(this.getPayload())
                .then(function() {
                    that.$router.push({ name: 'step7_expense' });
                })
                .catch(function (error) {
                    const response = error.response;
                    if (response.data !== undefined && response.data.error !== undefined) {
                        that.errorDetails = response.data.error.messages;
                        that.errorMessages = ['Er ontbreken gegevens in deze stap'];
                    } else {
                        that.errorMessages = ['Onbekende fout!'];
                    }
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function() {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
